export default function DemoLockedPanel({ title, body, onSignUp }) {
  return (
    <div style={{
      maxWidth: 480,
      margin: "60px auto",
      padding: 32,
      background: "var(--surface)",
      border: "1px solid var(--border)",
      borderRadius: 12,
      textAlign: "center",
      fontFamily: "'Geist', sans-serif",
    }}>
      <div style={{ fontSize: 36, marginBottom: 12 }}>🔒</div>
      <div style={{ fontFamily: "'Fraunces', serif", fontSize: 22, fontWeight: 500, marginBottom: 10, color: "var(--text)" }}>
        {title}
      </div>
      <div style={{ fontSize: 14, color: "var(--text2)", marginBottom: 22, lineHeight: 1.5 }}>
        {body}
      </div>
      <button
        onClick={onSignUp}
        style={{
          background: "var(--accent)",
          color: "#fff",
          border: "none",
          padding: "12px 24px",
          borderRadius: 8,
          fontSize: 14,
          fontWeight: 600,
          cursor: "pointer",
          fontFamily: "'Geist', sans-serif",
        }}
      >
        Sign Up to Unlock &rarr;
      </button>
    </div>
  );
}
